import request from "../http/index";

/**
 *
 * @param {*} data
 * @returns 首页热力图
 */

export async function QuotaReportProvinceSalesAmount(data = {}) {
  const res = await request.post(
    "/api/report/QuotaReport/ProvinceSalesAmount",
    data
  );
  return res.data;
}
/**
 *
 * @param {*} data
 * @returns 首页年度销售额
 */

export async function QuotaReportYearSalesAmount(data = {}) {
  const res = await request.post(
    "/api/report/QuotaReport/YearSalesAmount",
    data
  );
  return res.data;
}
/**
 *
 * @param {*} data
 * @returns 首页年度采购指标达成率
 */

export async function QuotaReportPurchaseQuotaSummary(data = {}) {
  const res = await request.post(
    "/api/report/QuotaReport/PurchaseQuotaSummary",
    data
  );
  return res.data;
}
/**
 *
 * @param {*} data
 * @returns 首页库存透视参考价格合计
 */

export async function QuotaReportStockCostSummary(data = {}) {
  const res = await request.post(
    "/api/report/QuotaReport/StockCostSummary",
    data
  );
  return res.data;
}

/**
 *
 * @param {*} data
 * @returns 首页商业报表
 */

export async function QuotaReportASNReportByL2(data = {}) {
  const res = await request.post("/api/report/QuotaReport/ASNReportByL2", data);
  return res.data;
}
